import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@interstate/components/Alert';
import { Box } from '@interstate/components/Box';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { FINANCE, LEASE } from '@makemydeal/dr-platform-types';
import { useToastDisappear } from '../common/DataLoadingToast/utils/useToastDisappear';

const FINANCE_MESSAGE = 'Down Payment, Term, and Rate (APR) have been carried over from the previous deal. Review Deal.';
const LEASE_MESSAGE =
    'Down Payment, Term, Money Factor (MF), Residual, and Mileage have been carried over from the previous deal. Review Deal.';
const BANNER_TIMEOUT = 15000;

const VehicleChangeRetentionBanner = () => {
    const isVehicleChangeSuccessful = useSelector(vehicleSelectors.showVehicleChangeSnackBar);
    const currentOfferType = useSelector(offerReduxSelectors.getCurrentOfferType);

    const { toastShown, triggerToast } = useToastDisappear(BANNER_TIMEOUT);

    useEffect(() => {
        if (isVehicleChangeSuccessful) {
            triggerToast();
        }
    }, [isVehicleChangeSuccessful, triggerToast]);

    if (!toastShown || (currentOfferType !== LEASE && currentOfferType !== FINANCE)) {
        return null;
    }

    const message = currentOfferType === LEASE ? LEASE_MESSAGE : FINANCE_MESSAGE;

    return (
        <Box sx={{ marginBottom: '0.7rem' }}>
            <Alert data-testid="vehicle-change-retention-banner" type="info">
                {message}
            </Alert>
        </Box>
    );
};

export default VehicleChangeRetentionBanner;
